<template>
  <div style="width: 100%">
    <v-toolbar flat color="white">
      <v-toolbar-title class="grey--text"
        >Configurar horario de atención</v-toolbar-title
      >
      <v-spacer />
    </v-toolbar>
    <template v-if="config_enabled">
      <v-tabs background-color="primary" dark>
        <v-tab @click="changeConfig('tab_1')">Días de atención</v-tab>
        <v-tab @click="changeConfig('tab_2')">Horarios de atención</v-tab>
      </v-tabs>
      <v-row>
        <v-col cols="12" v-if="selectedTab == 'tab_1'">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Día de atención</th>
                  <th class="text-left">Horario</th>
                  <th class="text-left">Estatus</th>
                  <th class="text-left">Opciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in dias" :key="item.id">
                  <td>{{ item.dia }}</td>
                  <td>{{ item.label }}</td>
                  <td>
                    <v-switch
                      v-model="item.status"
                      color="primary"
                      inset
                      hide-details
                      @click.native="editStatusDia(item)"
                    ></v-switch>
                  </td>
                  <td>
                    <v-icon
                      class="mr-2"
                      color="primary"
                      @click="agregarHorario(item.id)"
                    >
                      mdi-clock
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-col cols="12" v-if="selectedTab == 'tab_2'">
          <v-btn color="primary" dark class="mb-2" @click="openDialogHorario">
            Nuevo
          </v-btn>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Hora de inicio</th>
                  <th class="text-left">Hora fin</th>
                  <th class="text-left">Estatus</th>
                  <th class="text-left">Opciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in horarios" :key="item.id">
                  <td>{{ item.hora_inicio }} hrs</td>
                  <td>{{ item.hora_fin }} hrs</td>
                  <td>
                    <v-switch
                      v-model="item.status"
                      color="primary"
                      inset
                      hide-details
                      @click.native="editStatus(item)"
                    ></v-switch>
                  </td>
                  <td>
                    <v-icon
                      class="mr-2"
                      color="primary"
                      @click="editarHoras(item.id)"
                    >
                      edit
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </template>
    <div v-else>
      <v-card>
        <v-card-text>
          <p>
            Para configurar horarios de atención es necesario habilitar la
            configuración 'Habilita el horario de atención'. Puede acceder a las
            configuraciones en el siguiente botón.
          </p>
          <v-btn color="blue" @click="$router.push('/mas/configuraciones')"
            >Configuraciones</v-btn
          >
        </v-card-text>
      </v-card>
    </div>

    <v-dialog v-model="dialog" max-width="600px" persistent>
      <FormDiaAtencion
        v-if="dialog"
        @close="dialog = false"
        :horarios="horarios"
        :dia_horario="dia_horario"
        @listar="listarDias"
      />
    </v-dialog>
    <v-dialog v-model="dialog_horario" max-width="800px" persistent>
      <FormHorasAtencion
        v-if="dialog_horario"
        @close="dialog_horario = false"
        @listar="listarHorarios"
        @snackbar="snackbar = true"
        :horario="horario"
      />
    </v-dialog>
    <v-snackbar v-model="snackbar" top>
      Hora de inicio y Hora final son requeridos

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import FormDiaAtencion from "../../components/FormDiaAtencion";
import FormHorasAtencion from "../../components/FormHorasAtencion";

export default {
  name: "HorarioAtencion",
  components: {
    FormDiaAtencion,
    FormHorasAtencion,
  },
  data: () => ({
    selectedTab: "tab_1",
    dialog: false,
    dialog_horario: false,
    loading: false,
    dialog_delete: false,
    horarios: [],
    dias: [],
    dia_horario: null,
    horario: null,
    snackbar: false,
    config_enabled: false,
  }),
  mounted() {
    this.listarDias();
    this.listarHorarios();
    this.verifyEnableServiceHours();
  },
  methods: {
    changeConfig(tab) {
      this.selectedTab = tab;
    },

    verifyEnableServiceHours() {
      axios
        .get("/api/dias-atencion/verificarConfig", {
          params: { key: "ENABLE_SERVICE_HOURS" },
        })
        .then(({ data }) => {
          if (data.data) {
            this.config_enabled = data.data;
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {});
    },

    openDialogHorario() {
      this.horario = null;
      this.dialog_horario = true;
    },

    listarDias() {
      this.loading = true;
      axios
        .get("/api/dias-atencion/listar")
        .then(({ data }) => {
          data.data.forEach((item) => {
            if (item.horario) {
              item[
                "label"
              ] = `${item.horario.hora_inicio} a ${item.horario.hora_fin} hrs`;
            }
          });
          this.dias = data.data;
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    editStatusDia(item) {
      this.loading = true;
      axios
        .post("/api/dias-atencion/estatus", {
          ...item,
        })
        .then(() => {})
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    agregarHorario(id) {
      this.dia_horario = null;
      axios
        .get(`/api/dia-atencion/${id}`)
        .then(({ data }) => {
          if (data.data.horario) {
            data.data[
              "label"
            ] = `${data.data.horario.hora_inicio} a ${data.data.horario.hora_fin} hrs`;
          }
          this.dia_horario = data.data;
          this.dialog = true;
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    listarHorarios() {
      this.loading = true;
      axios
        .get("/api/horario-atencion/listar")
        .then(({ data }) => {
          data.data.forEach((item) => {
            item["label"] = `${item.hora_inicio} a ${item.hora_fin} hrs`;
          });
          this.horarios = data.data;
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    editStatus(item) {
      this.loading = true;
      axios
        .post("/api/horario-atencion/estatus", {
          ...item,
        })
        .then(() => {})
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    editarHoras(id) {
      axios
        .get(`/api/horario-atencion/${id}`)
        .then(({ data }) => {
          this.horario = data.data;
          this.dialog_horario = true;
          window.console.log(this.horario);
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
</style>
